import React from "react";
import { Row, Col } from "reactstrap";
import './signResponse.css';

const ContractAmendmentSignDeclined = props => {

    return (
        <div className='bl-back-image'>
            <Row>
                <Col xl="12" lg="12" md="12" sm="12" xm="12" style={{marginTop: '10%'}}>
                    <div>
                        <h1 className="text-center text-danger text-congrats">
                            Contract Amendment Sign Declined :(
                        </h1>

                        <div className="text-center pl-2 pr-2" style={{fontSize: '20px', marginTop: '40px'}}>
                            <p>
                                You have declined to sign the contract amendment, this will cause delays in the distribution process.<br/> 
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ContractAmendmentSignDeclined;